function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Account from 'modules/Account';
import messages from '../../messages';
import Create from '../../partials/Create';
import Join from '../../partials/Join';
const JoinOrCreate = ()=>{
    const loadedIdentity = useSelector(Account.selectors.loadedIdentity);
    const identities = useSelector(Account.selectors.identities);
    const { countryCode } = loadedIdentity;
    const countryCodes = identities.filter((identity)=>Account.constants.BUSINESS_SCOPES.includes(identity.scope)).map((identity)=>identity.countryCode);
    const defaultCountryCode = countryCodes.includes(countryCode) ? countryCode : countryCodes[0];
    return /*#__PURE__*/ _jsxs("section", {
        className: "mt-8",
        children: [
            /*#__PURE__*/ _jsx("a", {
                id: "join"
            }),
            /*#__PURE__*/ _jsx("header", {
                className: "section__header",
                children: /*#__PURE__*/ _jsx("h4", {
                    className: "text--h4",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.joinOrCreateOrganization))
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "section",
                children: [
                    /*#__PURE__*/ _jsx(Join, {
                        countryCodes: countryCodes,
                        defaultCountryCode: defaultCountryCode
                    }),
                    /*#__PURE__*/ _jsx("hr", {
                        className: "form-divider"
                    }),
                    /*#__PURE__*/ _jsx(Create, {})
                ]
            })
        ]
    });
};
export default JoinOrCreate;
